import type { IconData } from '@stacksjs/iconify-core'

export const polygon: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16.5 20.794h-9a1 1 0 0 1-.866-.5l-4.5-7.794a1 1 0 0 1 0-1l4.5-7.794a1 1 0 0 1 .866-.5h9a1 1 0 0 1 .866.5l4.5 7.794a1 1 0 0 1 0 1l-4.5 7.794a1 1 0 0 1-.866.5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default polygon
